var map = {
	"./avatars/avatar": 24,
	"./avatars/avatar-3": 25,
	"./avatars/avatar-3.png": 25,
	"./avatars/avatar.jpg": 24,
	"./errors-images/404-error": 26,
	"./errors-images/404-error.png": 26,
	"./errors-images/505-error": 27,
	"./errors-images/505-error.png": 27,
	"./lexiqamus-logo": 28,
	"./lexiqamus-logo.png": 28,
	"./logo-icon": 29,
	"./logo-icon.png": 29,
	"./lq-logo": 30,
	"./lq-logo.png": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;